export enum CloseModalButtonVariants {
  dark = 'dark',
  light = 'light',
}

export function isCloseModalButtonVariant(value: string): value is CloseModalButtonVariants {
  return Object.values(CloseModalButtonVariants).includes(value as CloseModalButtonVariants);
}
